import { render, staticRenderFns } from "./CreatePaymentsDialog.vue?vue&type=template&id=f05bb798&scoped=true&"
import script from "./CreatePaymentsDialog.vue?vue&type=script&lang=ts&"
export * from "./CreatePaymentsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePaymentsDialog.vue?vue&type=style&index=0&id=f05bb798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05bb798",
  null
  
)

export default component.exports